export default __webpack_public_path__ + "static/media/logo.ef9909f2.svg";